<template>
  <div class="miya-menu" :class="showMenu?'show':''">
    <div class="phoneBg" @click="showMenu = false"></div>
    <div class="phoneMenuBtn" v-if="pageWidth < 800" @click="showMenu = !showMenu"><i :class="showMenu ? 'el-icon-s-fold': 'el-icon-s-unfold'"></i></div>
    <div class="bg">
      <img class="img" src="@assets/images/login/bg.png">
    </div>
    <img class="logo" src="@assets/images/home/miyaLOGO.svg" @click.stop="clickBackHome()">
    <div class="menu-box">
      <div class="item" v-for="(item, index) in menu" :key="'menu'+index">
        <div class="menu" :class="{active: isActiveMenu(item)}" @click.stop="clickMenu(item, index)">
          <cx-icon :normal='item.icon' :active='item.icon1' :isActive="isActiveMenu(item)"></cx-icon>
          <p class="name">{{item.label}}</p>
          <i class="icon-arrow" :class="{expand: item.isExpand}" v-if="item.child.length > 0"></i>
        </div>
        <div class="submenu-box" v-if="item.isExpand">
          <p class="submenu" v-for="(i, idx) in item.child" :key="'submenu'+idx" :class="{activeSubmenu: i.name === activeMenu}" @click.stop="clickSubmenu(i, idx)">{{i.label}}</p>
        </div>
        <div class="borderLine" v-if="item.borderLine"></div>
      </div>
    </div>
  </div>
</template>
<script>
import cxIcon from './cxIcon.vue'
export default {
  data () {
    return {
      menu: [
        {label: '', labelName: 'menu.m1', name: 'dashboard', icon: '1.png', icon1: '1-1.png', isExpand: false, borderLine: true, child: [
        ]},
        {label: '', labelName: 'menu.m2', name: 'dynamic ', icon: '2.png', icon1: '2-1.png', isExpand: false, child: [
          {label: '', labelName: 'menu.m2_1', name: 'proxyCountry', },
          {label: '', labelName: 'menu.m2_2', name: 'proxyCity', },
          {label: '', labelName: 'menu.m2_3', name: 'purchaseTraffic', },
        ]},
        {label: '', labelName: 'menu.m3', name: 'static ', icon: '3.png', icon1: '3-1.png', isExpand: false, child: [
          {label: '', labelName: 'menu.m3_1', name: 'purchaseAgent', },
          {label: '', labelName: 'menu.m3_2', name: 'purchasedDetails', },
        ]},
        {label: '', labelName: 'menu.m4', name: 'historicalOrders', icon: '4.png', icon1: '4-1.png', isExpand: false, borderLine: true, child: [
        ]},
        {label: '', labelName: 'menu.m5', name: 'help ', icon: '5.png', icon1: '5-1.png', isExpand: false, child: [
          {label: '', labelName: 'menu.m5_1', name: 'helpDocuments', },
          {label: '', labelName: 'menu.m5_2', name: 'customerPolicy', },
        ]},
        {label: '', labelName: 'menu.m6', name: 'developerAPI', icon: '6.png', icon1: '6-1.png', isExpand: false, child: [
        ]},
        {label: '', labelName: 'menu.m7', name: 'inviteReward', icon: '7.png', icon1: '7-1.png', isExpand: false, child: [
        ]},
      ],
      activeMenu: 'dashboard',
      showMenu: false
    }
  },
  mounted () {
    this.pageWidth >= 800 ? this.showMenu = true : ''
    this.getData()
    this.getActiveMenu()
  },
  methods: {
    getData () {
      this.menu.map((val, index) => {
        this.$set(this.menu[index], 'label', this.$t(val.labelName))
        if (val.child) {
          val.child.map((child, idx) => {
            this.$set(this.menu[index].child[idx], 'label', this.$t(child.labelName))
          })
        }
      })
    },
    isActiveMenu (item) {
      if (item.name === this.activeMenu) {
        return true
      } 
      let child = item.child.find(val => {return val.name === this.activeMenu})
      if (child) {
        return true
      }    
    },
    clickMenu (item, index) {
      this.$set(this.menu[index], 'isExpand', !item.isExpand)
      if (item.name === 'developerAPI') {
        window.open('https://miyaip.readme.io/reference/getting-started-with-your-api-1')
        return
      }
      if (item.child.length === 0) {     
        if (this.pageWidth < 800) {
          this.showMenu = false
        }  
        this.$router.push(`/${item.name}`)
      }
    },
    clickSubmenu (i, idx) {
      if (i.name === 'helpDocuments') {
        window.open('https://help.miyaip.net/')
        return
      } 
      if (this.pageWidth < 800) {
        this.showMenu = false
      }  
      this.$router.push(`/${i.name}`)
    },
    getActiveMenu () {      
      let name = this.$route.name
      this.menu.map(val => {
        if (val.name === name && val.child.length === 0) {
          this.activeMenu = name
          return
        }
        val.child.map(child => {
          if (name === child.name) {
            val.isExpand = true
            this.activeMenu = name
          }
        })
      })
    },
    clickBackHome () {
      this.$router.push('/home')
    }
  },
  watch: {
    language () {
      this.getData()
    },
    $route () {
      this.getActiveMenu()
    }
  },
  components: {cxIcon}
}
</script>
<style scoped lang="stylus">
.miya-menu
  width 240px
  min-width 240px
  background-color $c1
  position relative
  .bg
    position absolute
    width 100%
    height 100%
    background: linear-gradient(120deg, rgba(255,143,16,0.2) 0%,rgba(20,17,14,0) 70%, rgba(20,17,14,0) 100%);
    z-index 0
    overflow hidden
    .img
      position absolute
      width 80vw
      top 30%
      opacity 0.2
      left calc(-40vw - 50%)
  .logo
    display block
    width 138px
    margin 46px 20px
    z-index 1
    position relative
  .menu-box
    position relative
    z-index 1
    .menu, .submenu-box
      cursor pointer
    .item
      color $c7
      .menu
        display flex
        padding 18px 0 18px 0
        opacity 0.6
        margin 0 20px
        .name
          margin-left 10px
          line-height 20px
          font-size $f16
          flex 1
        .icon-arrow
          width 0
          height 0
          margin-top 8px
          position relative
          right -3px
          border 5px solid transparent
          border-left 6px solid $c7
          transform-origin 3px center
          animation rotate 0.3s ease forwards
        .expand
          animation rotate1 0.3s ease forwards
        &:hover
          opacity 1
      .active
        opacity 1
        position relative
        color $c8
        &:before
          content ''
          position absolute
          top calc(50% - 12px)
          left -20px
          display block
          width 5px
          height 24px
          border-radius 0 10px 10px 0
          background-color $c8
        .name
          fontWeight()
        .icon-arrow
          border-left 7px solid $c8
      .submenu-box
        padding-left 20px
        background-color #0C0600
        .submenu
          opacity 0.6
          font-size $f14
          line-height 56px
          &:hover
            opacity 1
        .activeSubmenu
          opacity 1
          fontWeight()
          color $c8
      .borderLine
        height 1px
        margin 0 20px
        background-color rgba(255,255,255,0.15)
@keyframes rotate
  0%
    transform rotate(90deg)
  100%
    transform rotate(0)
@keyframes rotate1
  0%
    transform rotate(0)
  100%
    transform rotate(90deg)
@media screen and (max-width: 1440px)
  .miya-menu
    width 200px
    min-width 200px
    .menu-box
      .item
        .menu
          margin 0 12px
          .name
            margin-left 4px
            font-size $f14
        .submenu-box
          .submenu
            font-size $f13
      .active
        &:before
          left -12px
@media screen and (max-width: 800px)
  .miya-menu
    position absolute
    width 2.6rem
    min-width 2.6rem
    z-index 10
    top 0
    left 0
    height 2.6rem
    background-color $c7
    .phoneMenuBtn
      font-size 1.2rem
      color $c2
      z-index 3
      position absolute
      width 2.6rem
      height 2.6rem
      top 0
      left 0
      text-align center
      line-height 2.6rem
      .el-icon-s-unfold
        font-weight 100
    .bg, .logo, .menu-box, .phoneBg
      display none
  .show
    width 58%
    min-width 58%
    height 100vh
    z-index 13
    background-color $c1
    .phoneBg
      position absolute
      top 0
      left 0
      display block
      width 100vw
      height 100vh
      background-color rgba(0,0,0,0.5)
    .phoneMenuBtn, .bg, .menu-box
      display block
    .phoneMenuBtn
      color $c7
    .menu-box
      margin-top 50px
      .item
        .menu
          padding 0.65rem 0
          .name
            font-size 0.66rem
            line-height 1rem
        .submenu-box
          .submenu
            line-height 48px
            font-size 0.6rem
</style>